import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-product',
  templateUrl: './about-product.component.html',
  styleUrls: ['./about-product.component.scss']
})
export class AboutProductComponent implements OnInit {

  leaders: any[];
  heroImageUrl = 'assets/aboutpage.png';
  private readonly heroFallbackUrl = 'assets/prod-feature1.png';
  constructor() { }

  ngOnInit() {
    // TODO API call for leaders.
    this.leaders = [
      { desc: 'Candidate information is anonymized and evaluated against a well-defined rubric to enable hiring managers to make data-backed decisions with confidence.Candidate information is anonymized and evaluated against a well-defined rubric to enable hiring managers to make data-backed decisions with confidence.', img: '../../../assets/individual.png' },
      { desc: 'Candidate information is anonymized and evaluated against a well-defined rubric to enable hiring managers to make data-backed decisions with confidence.Candidate information is anonymized and evaluated against a well-defined rubric to enable hiring managers to make data-backed decisions with confidence.', img: '../../../assets/individual.png' }
    ];
  }

  openEmailClient(): void {
    // Ensure the mailto link opens properly
    window.location.href = 'mailto:support@evaltrix.com';
  }

  onHeroImageError(event: Event): void {
    const fallback = this.heroFallbackUrl;
    this.heroImageUrl = fallback;
    const target = event?.target as HTMLImageElement | null;
    if (target) {
      target.src = fallback;
    }
  }

}
